import React from 'react'

function LeaveInside() {
  return (
    <div>LeaveInside</div>
  )
}

export default LeaveInside